// extracted by mini-css-extract-plugin
export var box = "_5d-1";
export var checkboxRow = "_5d-8";
export var checked = "_5d-2";
export var descriptionSpacer = "_5d-a";
export var disabled = "_5d-3";
export var icon = "_5d-6";
export var input = "_5d-0";
export var labelSpacer = "_5d-9";
export var medium = "_5d-5";
export var small = "_5d-4";
export var text = "_5d-7";